import 'bootstrap-notify';
import topbarSelect from './topbarSelect.js';

export default {
	init() {
	},
	finalize() {
		topbarSelect.init();
	},
};
